// components/AboutSectionWrapper.jsx
import React, { useState } from "react";
import AboutSectionLayout from "./AboutSectionLayout";
import { aboutMain, aboutWedding } from "./AboutData";
import { motion } from "framer-motion";
import styles from "../styles/AboutSectionWrapper.module.css";

export default function AboutSectionWrapper() {
  const [view, setView] = useState(0);

  const sections = [aboutMain, aboutWedding];

  return (
    <div>
      <div className={styles.aboutToggle}>
        <button
          className={view === 0 ? "active" : ""}
          onClick={() => setView(0)}
        >
          Restaurant
        </button>

        <button
          className={view === 1 ? "active" : ""}
          onClick={() => setView(1)}
        >
          Weddings
        </button>
      </div>

      <motion.div
        layout
        transition={{ duration: 0.3 }}
      >
        <AboutSectionLayout data={sections[view]} />
      </motion.div>

    </div>
  );
}